import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'formatAmPmTime',
    pure: true
})

    // Time is received as 03:30 PM -> 15:30 || 11:30 AM -> 11:30

export class FormatAmPmTimePipe implements PipeTransform {
    constructor(private _datePipe: DatePipe) { }
    transform(rawTime: string): string {
        try {
            const [hour, minutes] = rawTime.split(':').map((value) => parseInt(value, 10));
            const today = new Date();
            const [month, day, year] = [
                today.getMonth(),
                today.getDate(),
                today.getFullYear(),
            ];
            const dateFromStr = new Date(year, month, day, hour, minutes);
            return this._datePipe.transform(dateFromStr, 'hh:mm aaa');
        } catch (e) {
            console.log('Error formatting time:' + e);
        }
    }
}